var map = {
	"./avalanche/launchpad/busd.png": "094d",
	"./avalanche/launchpad/dai.png": "6df2",
	"./binance/launchpad/busd.png": "f5fc",
	"./binance/launchpad/dai.png": "3135",
	"./binance/launchpad/finished-stage.png": "b21e",
	"./binance/launchpad/launchpad-banner-bg-sm.png": "e1cd",
	"./binance/launchpad/launchpad-banner-bg.png": "bbcb",
	"./binance/launchpad/wait-next-stage.png": "6abf",
	"./ethereum/launchpad/busd.png": "3245",
	"./ethereum/launchpad/dai.png": "a187",
	"./ethereum/launchpad/finished-stage.png": "209a",
	"./ethereum/launchpad/launchpad-banner-bg-sm.png": "3ae9",
	"./ethereum/launchpad/wait-next-stage.png": "b97c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5145";